var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEksLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 45,
    viewBox: "0 0 38 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6 10.25L21.6 0.249999C21.3 0.0499994 20.9 0.0499994 20.6 0.249999C20.2 0.349999 20 0.65 20 1.05V10.05C20 10.35 20.2 10.75 20.5 10.95L28 15.65V27.55L19 32.95L10 27.55V15.65L17.5 10.95C17.8 10.75 18 10.45 18 10.05V1.05C18 0.65 17.8 0.35 17.5 0.15C17.2 -0.05 16.8 -0.05 16.5 0.15L0.5 10.15C0.2 10.35 0 10.75 0 11.05V32.05C0 32.45 0.2 32.75 0.5 32.95L18.5 43.95C18.6 44.05 18.8 44.05 19 44.05C19.2 44.05 19.4 44.05 19.5 43.95L37.5 32.95C37.8 32.75 38 32.45 38 32.05V11.05C38 10.75 37.8 10.35 37.6 10.25ZM36 31.45L19 41.85L2 31.45V11.65L16 2.95V9.55L8.5 14.25C8.2 14.35 8 14.75 8 15.05V28.05C8 28.45 8.2 28.75 8.5 28.95L18.5 34.95C18.6 35.05 18.8 35.05 19 35.05C19.2 35.05 19.4 35.05 19.5 34.95L29.5 28.95C29.8 28.75 30 28.45 30 28.05V15.05C30 14.75 29.8 14.35 29.5 14.25L22 9.45V2.85L36 11.55V31.45Z",
    fill: "#ED7100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2 27.55H22L17.2 21.55V27.55H15.2V14.55H17.2V19.85L21.7 14.55H23.9L18.9 20.95L23.2 26.35L24.2 27.55Z",
    fill: "#ED7100"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEksLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eks-logo.0364f4bf3a23bce9d0369138113ee3d9.svg";